export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const ADMIN_EMAILS = [
  "mart@mart-mineral.com",
  "omrishahal@gmail.com",
  "mmicrommineral@gmail.com"
];

export const WHATSAPP_MESSAGE = "שלום, שמי אמנון ואני מ-M'ART 🌿קהילה לפיתוח דאודורנט טבעי בהכנה עצמית. האם תהיו מעוניינים לקבל מארז דוגמית בחינם? זה יכול להיות הצעד הראשון לפעם הבאה שתכינו דאודורנט בעצמכם! אשמח לספר לך עוד: www.deo.co.il";

export const EMAIL_SUBJECT = "ברוכים הבאים ל-M'ART!";
export const EMAIL_TEMPLATE = "היי {name},\n\nראיתי שהצטרפת לקהילת M'ART!\n\nרציתי להציע לך קופון מיוחד למארז הראשון שלך.\n\nאשמח לענות על כל שאלה.\n\nאמנון\nM'ART";

export const getAuthHeaders = () => {
  const headers = { "Content-Type": "application/json" };
  const storedToken = localStorage.getItem('mart_session_token');
  if (storedToken) {
    headers['Authorization'] = `Bearer ${storedToken}`;
  }
  return headers;
};

export const formatDate = (dateString) => {
  if (!dateString) return "לא ידוע";
  const date = new Date(dateString);
  return date.toLocaleDateString('he-IL', {
    year: 'numeric', month: 'short', day: 'numeric',
    hour: '2-digit', minute: '2-digit'
  });
};

export const formatShortDate = (dateString) => {
  if (!dateString) return "—";
  return new Date(dateString).toLocaleDateString('he-IL', { day: 'numeric', month: 'short' });
};

export const getRelativeTime = (dateString) => {
  if (!dateString) return "";
  const diffMs = new Date() - new Date(dateString);
  const diffMins = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  if (diffMins < 5) return "עכשיו";
  if (diffMins < 60) return `לפני ${diffMins} דק'`;
  if (diffHours < 24) return `לפני ${diffHours} שע'`;
  if (diffDays === 1) return "אתמול";
  if (diffDays < 7) return `לפני ${diffDays} ימים`;
  if (diffDays < 30) return `לפני ${Math.floor(diffDays / 7)} שבועות`;
  return formatShortDate(dateString);
};

export const isUserLive = (lastLogin) => {
  if (!lastLogin) return false;
  return (new Date() - new Date(lastLogin)) < 5 * 60 * 1000;
};

export const getUserTagType = (u) => {
  const createdAt = new Date(u.created_at);
  const weekAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
  if (u.coupon_used || u.purchased_pack) {
    if ((u.login_count || 0) > 5) return "vip";
    return "purchased";
  }
  if (createdAt >= weekAgo) return "new";
  return "regular";
};

export const TAG_CONFIG = {
  vip:       { label: "VIP",  bg: "bg-amber-700", text: "text-amber-50" },
  purchased: { label: "רכש",  bg: "bg-[#6B8E6B]", text: "text-white" },
  new:       { label: "חדש",  bg: "bg-[#7B8C96]", text: "text-white" },
  regular:   { label: "רגיל", bg: "bg-[#2C3329]/10", text: "text-[#2C3329]" },
};

export const openWhatsApp = (phone, message) => {
  let cleanPhone = phone.replace(/[\s\-\(\)]/g, '');
  if (cleanPhone.startsWith('0')) cleanPhone = '972' + cleanPhone.substring(1);
  else if (!cleanPhone.startsWith('972') && !cleanPhone.startsWith('+972')) cleanPhone = '972' + cleanPhone;
  cleanPhone = cleanPhone.replace('+', '');
  window.open(`https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`, '_blank');
};

export const openEmail = (email, name) => {
  const subject = encodeURIComponent(EMAIL_SUBJECT);
  const body = encodeURIComponent(EMAIL_TEMPLATE.replace('{name}', name || 'שם'));
  window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
};

export const computeStats = (users) => {
  if (users.length === 0) return null;
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today.getTime() - 86400000);
  const weekAgo = new Date(today.getTime() - 7 * 86400000);
  const twoWeeksAgo = new Date(today.getTime() - 14 * 86400000);
  const monthAgo = new Date(today.getTime() - 30 * 86400000);

  let todayCount = 0, weekCount = 0, lastWeekCount = 0, monthCount = 0;
  let withPhone = 0, receivedKit = 0, contacted = 0, totalPdfDownloads = 0;
  let activeIn24h = 0, purchasedPack = 0;

  users.forEach(u => {
    const createdAt = new Date(u.created_at);
    const lastLogin = u.last_login ? new Date(u.last_login) : null;
    if (createdAt >= today) todayCount++;
    if (createdAt >= weekAgo) weekCount++;
    if (createdAt >= twoWeeksAgo && createdAt < weekAgo) lastWeekCount++;
    if (createdAt >= monthAgo) monthCount++;
    if (u.phone) withPhone++;
    if (u.received_trial_kit) receivedKit++;
    if (u.whatsapp_contacted) contacted++;
    totalPdfDownloads += (u.pdf_download_count || 0);
    if (lastLogin && lastLogin >= yesterday) activeIn24h++;
    if (u.coupon_used || u.purchased_pack) purchasedPack++;
  });

  const weeklyGrowth = lastWeekCount > 0
    ? Math.round(((weekCount - lastWeekCount) / lastWeekCount) * 100)
    : weekCount > 0 ? 100 : 0;

  return {
    totalUsers: users.length,
    todayUsers: todayCount,
    weekUsers: weekCount,
    monthUsers: monthCount,
    withPhone,
    receivedKit,
    contacted,
    totalPdfDownloads,
    weeklyGrowth,
    activeIn24h,
    purchasedPack,
    conversionRate: users.length > 0 ? Math.round((purchasedPack / users.length) * 100) : 0,
  };
};
